module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "register"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('newRegister')))]), _vm._v(" "), _c('email-register', {
    staticClass: "email-phone-register"
  }), _vm._v(" "), _c('third-part-login', {
    staticClass: "oauth-login"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14cad57e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/register/Register.vue
// module id = 1267
// module chunks = 1